/**
 * Utility functions for comparison features
 */

/**
 * Format category ID to readable name
 */
function formatCategoryName(categoryId: string): string {
  return categoryId
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Extract unique categories from comparison items with counts
 */
export function extractCategories(
  items: Array<{ category_id: string; category_name?: string }>
): Array<{ id: string; name: string; count: number }> {
  const categoryMap = new Map<string, { name: string; count: number }>();

  for (const item of items) {
    const existing = categoryMap.get(item.category_id);
    if (existing) {
      existing.count++;
    } else {
      categoryMap.set(item.category_id, {
        name: item.category_name || formatCategoryName(item.category_id),
        count: 1,
      });
    }
  }

  return Array.from(categoryMap.entries()).map(([id, data]) => ({
    id,
    name: data.name,
    count: data.count,
  }));
}
